import React from 'react';
import { init } from '../model';
const CreateContext = React.createContext(init());
export default CreateContext;